module.exports = __webpack_public_path__ + "static/media/twitter.174068d8.png";